import CheckIcon from '@mui/icons-material/Check';
import { commentMonitorConditionsText } from '../Drawer/ClinicalEventForm';
import styles from './index.module.scss';

const MonitorText = () => {
  return (
    <div className={styles.monitorText}>
      <CheckIcon className={'mr-1'} />
      {commentMonitorConditionsText}
    </div>
  );
};

export default MonitorText;
